module.exports = __webpack_public_path__ + "static/img/solution_img_1.815d391.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/nav-solution/solution-h/solution_img_1.png
// module id = ufNB
// module chunks = 22